/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  '2horpanel': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="nonzero" _fill="none"><circle pid="0" _fill="#8300BF" cx="12" cy="12" r="12"/><path pid="1" d="M19.5 6.5v11h-15v-11h15zm-1 6h-13v4h13v-4zm0-5h-13v4h13v-4z" _fill="#FFF"/></g>'
  }
})
